import { createCarouselLayoutManager } from './createCarouselLayoutManager';

export const carouselLayoutManager = createCarouselLayoutManager({
  spaceBetween: 2,
  slidesOffsetBefore: 16,
  slidesOffsetAfter: 16,
});
